import {useEffect, useState} from "react";
import {axiosRequest} from './axios'
import {Accelerator} from "../interfaces/accelerator";

export const useAxios = (url: string): [boolean, Accelerator[], number, ((value: (((prevState: number) => number) | number)) => void), ((value: (((prevState: Accelerator[]) => Accelerator[]) | Accelerator[])) => void)] => {
    const [accelerators, setAccelerators] = useState<Accelerator[]>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [averageScore, setAverageScore] = useState(0);

    useEffect(() => {
        const getAllFetchedData = async () => {
            await axiosRequest("GET", url).then((response) => {
                setAccelerators(response.data.accelerators)
                setAverageScore(response.data.avg)
                setLoaded(true)
            }).catch(error => console.error(`Error: ${error}`));
        }
        getAllFetchedData();
    }, [url]);

    return [loaded, accelerators, averageScore, setAverageScore, setAccelerators];
}